export enum WizardHotelPWAv2Views {
  DEFAULT = "default",
  HOTWIRE = "hotwire",
  HTG = "htg",
  ROW = "row",
}
